import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const LinkedinIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3c0-1.1.9-2 2-2zM3.76 16.5h2.68V7.83H3.76zm9.59-8.93C11.5 7.57 10.73 9 10.73 9V7.83H8.16v8.67h2.57v-4.55c0-1.22.56-1.94 1.64-1.94.99 0 1.46.7 1.46 1.94v4.55h2.67v-5.49c0-2.32-1.32-3.44-3.15-3.44M5.09 3.5A1.6 1.6 0 0 0 3.5 5.1c0 .88.71 1.6 1.59 1.6a1.6 1.6 0 0 0 1.58-1.6c0-.88-.7-1.6-1.58-1.6"
      clipRule="evenodd"
    />
  </svg>
);
